import { useContext } from 'react'
import LoginContext from '../context/LoginContext'

//Se encargara de actualizar el estado para los datos realcionados al usuario
export const useLogin = () => {
  const {user, setUser, route, setRoute, component, setComponent} = useContext(LoginContext)

  return { user, setUser, route, setRoute, component, setComponent }
}